export default "__VITE_ASSET__lPb7gpEj__"